import { MAKE_WEBHOOK_URL, MAKE_WEBHOOK_ENABLED } from '@/lib/tp13Config';

/**
 * Envoie un événement au webhook Make (si activé)
 * @param eventName Nom de l'événement (ex: "lead.pipeline", "doc.status")
 * @param payload Données de l'événement
 * @returns true si succès ou désactivé, throw Error si échec
 */
export async function postEvent(eventName: string, payload: any): Promise<boolean> {
  // Si webhook désactivé ou URL vide, ne rien faire
  if (!MAKE_WEBHOOK_ENABLED || !MAKE_WEBHOOK_URL) {
    return true;
  }

  try {
    const response = await fetch(MAKE_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: eventName,
        payload,
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`MAKE_WEBHOOK_FAILED: ${response.status} ${response.statusText}`);
    }

    return true;
  } catch (err) {
    throw new Error(
      `Erreur webhook Make: ${err instanceof Error ? err.message : 'Erreur inconnue'}`
    );
  }
}

/**
 * Version silencieuse de postEvent qui ne throw jamais
 * Utilisée pour ne pas bloquer les opérations critiques
 */
export async function postEventSilent(eventName: string, payload: any): Promise<void> {
  try {
    await postEvent(eventName, payload);
  } catch (err) {
    // Log l'erreur mais ne la propage pas
    console.warn(`[Webhook Make] Échec silencieux pour ${eventName}:`, err);
  }
}